import React, { useMemo } from 'react';
import { format } from 'date-fns';
import TeamLabelCalendarGrid from '../TeamLabelCalendarGrid';
import { useIntersectionLazyMount } from '../../../shared/hooks/useIntersectionLazyMount';
import { getDayTimeGrid, getGridBodyHeightPx } from '../../utils/timeGrid';
import '../../styles/TeamLabelCalendar.css';

const DAY_HEADING_HEIGHT_PX = 52;
const DAY_SECTION_PADDING_PX = 24;

function getPlaceholderMinHeight(day, companyHours) {
  const grid = getDayTimeGrid(day, companyHours);
  if (!grid) {
    return DAY_HEADING_HEIGHT_PX + 80;
  }
  return getGridBodyHeightPx(grid) + DAY_HEADING_HEIGHT_PX + DAY_SECTION_PADDING_PX;
}

export default function LazyWeekDaySection({
  day,
  companyHours,
  columns,
  appointmentsForDay,
}) {
  const dayKey = format(day, 'yyyy-MM-dd');
  const { ref, isVisible } = useIntersectionLazyMount({
    rootMargin: '720px 0px',
    once: true,
  });

  const placeholderMinHeight = useMemo(
    () => getPlaceholderMinHeight(day, companyHours),
    [day, companyHours]
  );

  const heading = (
    <h2 className="team-cal-v3__sticky-heading">
      <span className="team-cal-v3-week__day-name">{format(day, 'EEEE')}</span>
      <span className="team-cal-v3-week__day-date">{format(day, 'MMM d, yyyy')}</span>
    </h2>
  );

  return (
    <section ref={ref} className="team-cal-v3-week__day" data-day-key={dayKey}>
      {isVisible ? (
        <TeamLabelCalendarGrid
          selectedDate={day}
          companyHours={companyHours}
          columns={columns}
          appointmentsForDay={appointmentsForDay}
          stickyHeading={heading}
        />
      ) : (
        <div
          className="team-cal-v3-week__day-placeholder"
          style={{ minHeight: placeholderMinHeight }}
          aria-hidden="true"
        >
          {heading}
        </div>
      )}
    </section>
  );
}
